var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.499282 8.49937H1.88828V15.4994C1.88828 15.632 1.94096 15.7592 2.03473 15.8529C2.1285 15.9467 2.25567 15.9994 2.38828 15.9994H15.6093C15.7419 15.9994 15.8691 15.9467 15.9628 15.8529C16.0566 15.7592 16.1093 15.632 16.1093 15.4994V8.49937H17.4993C17.6008 8.49922 17.6998 8.46819 17.7833 8.41039C17.8667 8.3526 17.9306 8.27078 17.9664 8.17581C18.0022 8.08084 18.0083 7.97722 17.9838 7.87872C17.9593 7.78022 17.9054 7.6915 17.8293 7.62437L9.32928 0.124367C9.23804 0.0442076 9.12074 0 8.99928 0C8.87783 0 8.76053 0.0442076 8.66928 0.124367L0.169282 7.62437C0.0931571 7.6915 0.0392672 7.78022 0.0147751 7.87872C-0.00971697 7.97722 -0.00365124 8.08084 0.032166 8.17581C0.0679832 8.27078 0.131855 8.3526 0.215293 8.41039C0.298731 8.46819 0.397782 8.49922 0.499282 8.49937ZM2.38828 7.49937H1.82128L8.99928 1.16637L16.1773 7.49937H15.6103C15.4777 7.49937 15.3505 7.55205 15.2567 7.64581C15.163 7.73958 15.1103 7.86676 15.1103 7.99937V14.9994H2.88928V7.99937C2.88928 7.86676 2.8366 7.73958 2.74284 7.64581C2.64907 7.55205 2.52189 7.49937 2.38928 7.49937H2.38828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.207 10H7.70703C7.44181 10 7.18746 10.1054 6.99992 10.2929C6.81239 10.4804 6.70703 10.7348 6.70703 11V15C6.70703 15.2652 6.81239 15.5196 6.99992 15.7071C7.18746 15.8946 7.44181 16 7.70703 16H10.207C10.4722 16 10.7266 15.8946 10.9141 15.7071C11.1017 15.5196 11.207 15.2652 11.207 15V11C11.207 10.7348 11.1017 10.4804 10.9141 10.2929C10.7266 10.1054 10.4722 10 10.207 10ZM7.70703 15V11H10.207V15H7.70703Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.81dd0fc962e7d30ba43d8b361f1f95f5.svg";
export { ForwardRef as ReactComponent };